import { render } from "./zonaIntegritas.vue?vue&type=template&id=ff07b8ae"
import script from "./zonaIntegritas.vue?vue&type=script&lang=js"
export * from "./zonaIntegritas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__